var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.startProject}},[_vm._v(_vm._s(_vm.$t('projectLive.publish')))])}
var staticRenderFns = []

export { render, staticRenderFns }